export default "__VITE_ASSET__BA0UqK2O__"